// Хелпер: гибкая проверка "access denied" (регистр и завершающая точка игнорируются)
export const isAccessDeniedMessage = (
  detail: string | undefined
): detail is string =>
  typeof detail === 'string' &&
  /(^|\W)access\s*denied(\W|$)/i.test(detail.replace(/\.*\s*$/, ''));
